import { useState } from "react";
import { FilterActions } from "./FilterActions.tsx";

export type CountRangeFilterValue = {
  min?: number;
  max?: number;
};

function countToInput(count?: number): string {
  return count === undefined ? "" : String(count);
}

function inputToCount(input: string): number | undefined {
  const count = Number(input);
  return input.trim() && Number.isInteger(count) && count >= 0
    ? count
    : undefined;
}

const countInputClassName =
  "w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-700";

export function CountRangeFilter({
  value,
  onApply,
  close,
}: {
  value: CountRangeFilterValue;
  onApply: (value: CountRangeFilterValue) => void;
  close: () => void;
}) {
  const [min, setMin] = useState(countToInput(value.min));
  const [max, setMax] = useState(countToInput(value.max));
  const apply = (next: CountRangeFilterValue) => {
    onApply(next);
    close();
  };

  return (
    <div className="flex flex-col gap-2 px-2">
      <div className="grid grid-cols-2 gap-2">
        <label className="flex flex-col gap-1 text-xs text-gray-500">
          Da
          <input
            inputMode="numeric"
            value={min}
            onChange={(e) => setMin(e.target.value)}
            placeholder="0"
            className={countInputClassName}
          />
        </label>
        <label className="flex flex-col gap-1 text-xs text-gray-500">
          A
          <input
            inputMode="numeric"
            value={max}
            onChange={(e) => setMax(e.target.value)}
            placeholder="∞"
            className={countInputClassName}
          />
        </label>
      </div>
      <FilterActions
        canClear={value.min !== undefined || value.max !== undefined}
        onClear={() => apply({})}
        onApply={() =>
          apply({ min: inputToCount(min), max: inputToCount(max) })
        }
      />
    </div>
  );
}
